import { render } from "./ThresholdRenderer.vue?vue&type=template&id=1ece8005"
import script from "./ThresholdRenderer.vue?vue&type=script&lang=js"
export * from "./ThresholdRenderer.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__